import React, { Component } from "react";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "jspdf-autotable";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import LeaveBalanceCalculationFilters from "../components/LeaveBalanceCalculationFilters";

const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class PreviousLeaveBalanceTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValues: {
        selectedDesignation: 0,
        selectedDepartment: 0,
        selectedBranch: 0,
        selectedRegion: 0,
      },
    };
  }

  componentDidMount() {
    this.setState(() => this._setTableData());
  }

  componentDidUpdate() {
    this._setTableData();
  }

  handleFilterValue = (filter, value) => {
    const currentFilters = this.state.filterValues;
    if (currentFilters[filter] === value) return;
    currentFilters[filter] = value;

    this.setState({
      filterValues: currentFilters,
    });
  };

  _setTableData() {
    let table;
    let list = [];
    let obj,
      one = [];

    let leaveBalanceData = this.props.data;
    if (
      Object.values(this.state.filterValues).find((val) => {
        return val !== 0;
      })
    ) {
      const selectedDesignation = this.state.filterValues.selectedDesignation;
      const selectedDepartment = this.state.filterValues.selectedDepartment;
      const selectedBranch = this.state.filterValues.selectedBranch;
      const selectedRegion = this.state.filterValues.selectedRegion;
      if (selectedDesignation !== 0) {
        leaveBalanceData = leaveBalanceData.filter((leaveBalance) => {
          return leaveBalance.designations_id === selectedDesignation;
        });
      }
      if (selectedDepartment !== 0) {
        leaveBalanceData = leaveBalanceData.filter((leaveBalance) => {
          return leaveBalance.departments_id === selectedDepartment;
        });
      }
      if (selectedBranch !== 0) {
        leaveBalanceData = leaveBalanceData.filter((leaveBalance) => {
          return leaveBalance.branch_id === selectedBranch;
        });
      }
      if (selectedRegion !== 0) {
        leaveBalanceData = leaveBalanceData.filter((leaveBalance) => {
          return leaveBalance.region_id === selectedRegion;
        });
      }
    }

    for (let i = 0; i < leaveBalanceData.length; i++) {
      obj = leaveBalanceData[i];
      one = {
        no: i + 1,
        fullname: obj.fullname,
        employment_id: obj.employment_id,
        designations: obj.designations,
        leave_balance_days: obj.leave_balance_days,
        deptname: obj.deptname,
        branch_name: obj.branch_name,
        region_name: obj.region_name,
      };
      list.push(one);
    }

    if ($.fn.dataTable.isDataTable("#dataTables-leaveBalance")) {
      table = $("#dataTables-leaveBalance").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-leaveBalance").empty();
    }

    let column = [
      { title: "No", data: "no" },
      { title: "Name", data: "fullname" },
      { title: "Employee Id", data: "employment_id" },
      { title: "Designation", data: "designations" },
      { title: "Leave Balance", data: "leave_balance_days" },
      { title: "Department", data: "deptname" },
      { title: "Branch", data: "branch_name" },
      { title: "Region", data: "region_name" },
    ];

    table = $("#dataTables-leaveBalance").DataTable({
      pageLength: 20,
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: true,
      dom: "Bfrtip",
      buttons: ["copy", "csv", "excel", "pdf"],
      data: list,
      columns: column,
    });
  }

  render() {
    return (
      <>
        {this.props.data.length !== 0 ? (
          <div>
            <LeaveBalanceCalculationFilters
              handleFilterValue={this.handleFilterValue}
              designations={this.props.designations}
              departments={this.props.departments}
              branches={this.props.branches}
              regions={this.props.regions}
            />
            <div className="margin-y">
              <table
                width="99%"
                className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive rm-marginTop"
                id="dataTables-leaveBalance"
              ></table>
            </div>
            {/* Vertical Spacing */}
            <div style={{ height: "400px" }}></div>
          </div>
        ) : (
          // Vertical Spacing
          <div style={{ height: "50px" }}></div>
        )}
      </>
    );
  }
}
